import { useAppDispatch, useAppSelector } from 'store/hooks';
import { openModal } from 'features/modal/modalSlice';
import { selectRoomLocked } from 'features/room/roomSlice';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';

export const useLock = () => {
  const dispatch = useAppDispatch();

  const roomLocked = useAppSelector(selectRoomLocked);

  const { hasPermissions } = usePermissions();
  const canControlRoomEntry = hasPermissions(PermissionTypes.controlRoomEntry);

  const triggerLockConfirmation = () => {
    dispatch(openModal(roomLocked ? 'unlockRoomConfirmation' : 'lockRoomConfirmation'));
  };

  return {
    roomLocked,
    canControlRoomEntry,
    triggerLockConfirmation,
  };
};
